import React, { useEffect, useRef, useState } from "react";
import DataTable from "../../components/Table";
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";
import Calendar from "../../components/Calendar/Calendar";
import { convertDateInFormat, formateDate } from "../../utils/utils";
import { useDispatch } from "react-redux";
import {
  getBankingReportData,
  saveBankingReport,
} from "../../store/actions/paymentActions";
import { generatePdf } from "../../utils/generatePdf";
import DepositSlipComponent from "./DepositSlipComponent";
import logo from "../../Assets/logo/logo_2x.svg";

const BankingAcknowledge = () => {
  const [bankingReportData, setBankingReportData] = useState([]);
  const [depositBankName, setDepositBankName] = useState("HDFC_BANK");
  const [pickUpPersonName, setPickupPersonName] = useState("");
  const [bankCashierName, setBankCashierName] = useState("");
  const [depositSlipDate, setSlipDate] = useState("");
  const [depositDate, setDepositDate] = useState("");
  const [showSlipDate, setShowSlipDate] = useState(false);
  const [showDepositDate, setShowDepositDate] = useState(false);
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [pdfData, setPdfData] = useState({});
  const [showPdf, setShowPdf] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
const [showBankMessage, setShowBankMessage] = useState('')
  const userDetails = localStorage.getItem("userDetails");
  const userId = JSON.parse(userDetails).user.code;
  const branchName = JSON.parse(userDetails).user.branch;
  const zone = JSON.parse(userDetails).user.zone;

  const slipRef = useRef(null);
  const dispatch = useDispatch();
  const isSubmitDisabled =
    !depositSlipDate || !depositDate || !selectedPayments.length;

  useEffect(() => {
    getTableData();
  }, []);

  const handleSelect = (value) => {
    setSelectedPayments((prev) =>
      prev.includes(value) ? [...prev] : [...prev, value]
    );
  };

  const handleDeselect = (value) => {
    setSelectedPayments((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev]
    );
  };

  const togglePageSelection = (pageRows) => {
    if (!pageRows || !pageRows.length) return;

    const pageIds = pageRows.map((row) => row.paymentId);

    setSelectedPayments((prev) => {
      const selectedSet = new Set(prev);

      const isPageFullySelected = pageIds.every((id) => selectedSet.has(id));
      // setIsCurrentPageSelected(isPageFullySelected)

      if (isPageFullySelected) {
        pageIds.forEach((id) => selectedSet.delete(id));
      } else {
        pageIds.forEach((id) => selectedSet.add(id));
      }

      return Array.from(selectedSet);
    });
  };

  const prepareTableData = (data = []) => {
    return data.map((item) => ({
      ...item,
      selectedForBanking: (
        <input
          type="checkbox"
          className="checkbox-field"
          checked={selectedPayments.includes(item.paymentId)}
          onChange={(e) => {
            if (e.target.checked) {
              handleSelect(item.paymentId);
            } else {
              handleDeselect(item.paymentId);
            }
          }}
        />
      ),
    }));
  };

  const getTableData = async () => {
    const resp = await dispatch(getBankingReportData(branchName, userId, zone));
    if (resp && resp.body) {
      setBankingReportData(resp.body);
      setShowBankMessage(resp.body.length === 0 && true)    
    }
  };

  const handleSubmit = async () => {
    const payload = {
      depositBankName,
      depositSlipDate: convertDateInFormat(
        new Date(depositSlipDate),
        "DD-MM-YYYY"
      ) + " 00:00:00",
      depositDate: convertDateInFormat(
        new Date(depositDate),
        "DD-MM-YYYY"
      ) + " 00:00:00",
      bankCashierName,
      pickUpPersonName,
      paymentId: selectedPayments,
    };
    const resp = await dispatch(saveBankingReport(payload));
    if (resp && resp.body) {
      setPdfData(resp.body);
      setShowPdf(true);
    }
  };

  const isAllSelected =
    bankingReportData.length > 0 &&
    selectedPayments.length === bankingReportData.length;

  const options = [
    {
      id: 1,
      key: "HDFC_BANK",
      text: "HDFC Bank",
      shortText: "HDFC Bank",
    },
    {
      id: 2,
      key: "AXIS_BANK",
      text: "AXIS Bank",
      shortText: "Axis Bank",
    },
  ];

  const handleChange = (event) => {
    const { value } = event.target;
    // if (value === "HDFC Bank") {
    //   setDepositBankName("HDFC_BANK");
    // } else if (value === "AXIS Bank") {
    //   setDepositBankName("AXIS_BANK");
    // }
    setDepositBankName(value);
  };

  const handlePdfDownload = async () => {
    try {
      setIsGenerating(true);
      await generatePdf(slipRef.current, "Deposit-Slip.pdf");
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <>
      {
      showBankMessage ?
      (
        <div class="empty-state">
  <div class="empty-state__icon">🔍</div>
  <h2 class="empty-state__title">No banking records found.</h2>
  <p class="empty-state__message">
     There are no acknowledged instruments pending for banking at this time. 
  </p>
</div>
      ) : (
    <>
      <div className="spec-grid">
        {/* bank name  */}
        <div className="label">Deposit Bank Name</div>
        <div className="colon">:</div>
        <div className="desc">
          <select
            className="form-control custom-dropdown"
            id="bankDropdown"
            value={depositBankName}
            onChange={(event) => handleChange(event)}
          >
            {options.map((option) => (
              <option key={option.key} value={option.key}>
                {option.text}
              </option>
            ))}
          </select>
        </div>

        {/* slip date  */}
        <div className="label">Deposit Slip Date</div>
        <div className="colon">:</div>
        <div className="desc">
          <div className="date-input-row">
            <div
              className="input-box"
              onClick={() => {
                setShowSlipDate(true);
              }}
            >
              <span className={`date-value`}>
                {depositSlipDate
                  ? formateDate(new Date(depositSlipDate))
                  : "DD/MM/YYYY"}
              </span>
              <span className="calendar_icon"></span>
            </div>
          </div>

          {showSlipDate && (
            <MobilePopUp
              hideCloseBtn={true}
              removeHeader={true}
              cssClass="daterange-mobilepopup"
            >
              <Calendar
                dob={""}
                maxDate={new Date()}
                onCancel={() => {
                  setShowSlipDate(false);
                  setSlipDate("");
                }}
                onApply={(sd) => {
                  setShowSlipDate(false);
                  setSlipDate(sd);
                }}
              />
            </MobilePopUp>
          )}
        </div>
      </div>

      {/* table  */}
      <DataTable
        cellHeaders={[
          "Mcustomer Acknowledgement No.",
          "Policy No",
          "Channel",
          "Payment Type",
          "Amount",
          "Type",
          "Cheque/ DD No.",
          "Cheque Date",
          "Instrument Bank name",
          "Payment Acceptance Date (i.e. Date of Acknowledgement)",
          "Accepted by (Branch Name)",
          "User ID acknowledged",
          {
            type: "button",
            label: "Select/ Deselect all",
            onClick: togglePageSelection,
          },
        ]}
        keys={[
          "mcustomerAcknowledgementNo",
          "policyNumber",
          "channel",
          "paymentType",
          "amount",
          "instrumentType",
          "chequeOrDdNumber",
          "chequeDate",
          "instrumentBankName",
          "paymentAcceptanceDate",
          "acceptedByBranchName",
          "userIdAcknowledged",
          "selectedForBanking",
        ]}
        data={prepareTableData(bankingReportData)}
        fileName="Reconciliation-Report"
        addSerialNo={true}
        showExcelDownload={false}
        PerPageApiData={false}
        isAllSelected={isAllSelected}
        paginationItems={bankingReportData}
        alwaysShown={false}
        setCurrentPageData
        isCurrentPageSelected
      />
      <div className="banking-acknowledge-content">
        <div className="spec-grid">
          {/* deposit date  */}
          <div className="label">Deposit Date</div>
          <div className="colon">:</div>
          <div className="desc">
            <div className="date-input-row">
              <div
                className="input-box"
                onClick={() => {
                  setShowDepositDate(true);
                }}
              >
                <span className={`date-value`}>
                  {depositDate
                    ? formateDate(new Date(depositDate))
                    : "DD/MM/YYYY"}
                </span>
                <span className="calendar_icon"></span>
              </div>
            </div>
            {showDepositDate && (
              <MobilePopUp
                hideCloseBtn={true}
                removeHeader={true}
                cssClass="daterange-mobilepopup"
              >
                <Calendar
                  dob={""}
                  maxDate={new Date()}
                  onCancel={() => {
                    setShowDepositDate(false);
                    setDepositDate("");
                  }}
                  onApply={(sd) => {
                    setShowDepositDate(false);
                    setDepositDate(sd);
                  }}
                />
              </MobilePopUp>
            )}
          </div>

          <div className="label">Branch Cashier Name</div>
          <div className="colon">:</div>
          <div className="desc">
            <div className="input-fields-wrapper">
              <input
                onChange={(e) => setBankCashierName(e.target.value)}
                value={bankCashierName}
                className="input-field"
                type="text"
                placeholder=""
                name="searchString"
              />
            </div>
          </div>

          {/* pickup person  */}
          <div className="label">Pick Up Person Name</div>
          <div className="colon">:</div>
          <div className="desc">
            <div className="input-fields-wrapper">
              <input
                onChange={(e) => setPickupPersonName(e.target.value)}
                value={pickUpPersonName}
                className="input-field"
                type="text"
                placeholder=""
                name="searchString"
              />
            </div>
          </div>
        </div>
        <div className={`submit-btn`}>
          <button
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
            className={isSubmitDisabled ? "disable-btn" : ""}
          >
            Generate Deposit Slip
          </button>
        </div>
      </div>
      {showPdf && (
        <>
          {/* PDF BUTTON */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "12px",
            }}
          >
            <button
              onClick={handlePdfDownload}
              disabled={isGenerating}
              style={{
                width: "200px",
                opacity: isGenerating ? 0.6 : 1,
                cursor: isGenerating ? "not-allowed" : "pointer",
              }}
            >
              {isGenerating ? "Generating PDF..." : "Download PDF"}
            </button>
          </div>

          {/* ONLY THIS PART GOES TO PDF */}
          <div ref={slipRef} className="pdf-wrapper">
            <div className="pdf-header-row">
              <div className="pdf-only-logo">
                <img
                  src={logo}
                  className="pdf-logo"
                  style={{ marginLeft: "30px" }}
                />
              </div>
            </div>

            <DepositSlipComponent data={pdfData} />

            <div className="pdf-only-disclaimer">
              This is a system generated deposit slip report.
            </div>
          </div>
        </>
      )}
    </>
      )}
    </>
  );
};

export default BankingAcknowledge;
